enum ContentSourceType {
    NotSet = 0,
    Askaprice = 1,
    CarKeys = 2,
    HonestJohn = 3,
    NextGreenCar = 4
}
export default ContentSourceType;
